import { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Frame, input } from "@/pages/PasswordReset";

export default function Waitlist() {
  const [form, setForm] = useState({ email: "", name: "", region: "", contact_consent: false });
  const [done, setDone] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/waitlist", form);
      setDone(data.message);
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  if (done) return (
    <Frame title="You're on the list" sub={done} testid="waitlist-done" img="/images/beach-dawn.jpg">
      <Link to="/" data-testid="waitlist-home-link" className="text-sm underline text-stone-600">Back to home</Link>
    </Frame>
  );
  return (
    <Frame title="Join the waitlist" sub="CAMRYN is opening to members in small groups. Leave your email and we'll send your personal invite." testid="waitlist-page" img="/images/beach-dawn.jpg">
      <form onSubmit={submit} className="space-y-4">
        <label className="block"><span className="text-sm font-medium text-stone-700">First name (optional)</span>
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} maxLength={60} data-testid="waitlist-name-input" className={input} /></label>
        <label className="block"><span className="text-sm font-medium text-stone-700">Email</span>
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="waitlist-email-input" className={input} autoComplete="email" /></label>
        <label className="block"><span className="text-sm font-medium text-stone-700">Province or state (optional)</span>
          <input value={form.region} onChange={(e) => setForm({ ...form, region: e.target.value })} maxLength={40} placeholder="e.g. Ontario" data-testid="waitlist-region-input" className={input} autoComplete="address-level1" /></label>
        <label className="flex gap-3 text-sm items-start cursor-pointer text-stone-700">
          <input type="checkbox" checked={form.contact_consent} onChange={(e) => setForm({ ...form, contact_consent: e.target.checked })} data-testid="waitlist-consent-checkbox" className="mt-0.5 h-5 w-5 shrink-0 accent-[#2D2926]" />
          <span>Email me my invite. See the <Link to="/legal/privacy" target="_blank" className="underline">Privacy Policy</Link>.</span>
        </label>
        {error && <p data-testid="waitlist-error" className="text-sm text-red-700 bg-red-50 rounded-lg px-3 py-2">{error}</p>}
        <button disabled={busy || !form.contact_consent} data-testid="waitlist-submit-btn" className="btn-ink w-full h-12 rounded-full font-semibold disabled:opacity-60">{busy ? "One moment…" : "Join the waitlist"}</button>
        <p className="text-sm text-stone-600"><Link to="/privacy-promise" data-testid="waitlist-privacy-promise-link" className="tap underline">How CAMRYN protects you</Link></p>
        <p className="text-sm text-stone-600">Have an invite? <Link to="/register" data-testid="waitlist-register-link" className="tap text-[#C86D51] font-semibold">Create your account</Link></p>
      </form>
    </Frame>
  );
}
